goog.provide('el8.ext.onboarding.ButtonSet');

goog.require('el8.model.base');
goog.require('el8.uiwidget.FormButtonSet');
goog.require('el8.template.ext.onboarding');

el8.ext.onboarding.ButtonSet = function() {
    el8.uiwidget.FormButtonSet.apply(this, arguments);
};
el8.ext.onboarding.ButtonSet.inheritsFrom(el8.uiwidget.FormButtonSet);

el8.ext.onboarding.ButtonSet.prototype.render = function() {

    if (this._container) {
        var html = el8.template.ext.onboarding.buttons({
            buttons: this._buttonsList
        });
        this._container.html(html);
    }

    return this;
};

